import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { NumberInput, SemanticUI, StackedToggle } from '@iterable/deprecated_react_components';
import Dropdown from 'core/dropdown';
import DateRangePickerRelative from 'core/dateRangePickerRelative';
import DistancePicker from 'core/distancePicker';
import LocationPicker from 'core/locationPicker';
import { body2, colors, spacing } from 'ui/theme';
import { Tooltip } from 'ui/tooltip';

export const ViewListLink = styled.a`
  ${body2};
  color: ${colors.textLink};
  text-decoration-color: ${colors.textLink};
  text-decoration-line: underline;
  display: flex;
  align-items: center;
  margin-left: ${spacing.half};
`;

export const SetField = styled.div`
  flex: 1 1 auto;
  background: #eff0f0; /** css file conversion */
  border: ${pxToRem(1)} solid #c3c3c5;
  min-height: ${pxToRem(38)}; /** css file conversion */
  opacity: 0.5;
`;

export const ReadOnlyLabel = styled.div`
  color: #717171; /** css file conversion */
  align-items: center;
  display: flex;
  justify-content: center;
  gap: ${pxToRem(10)}; /** css file conversion */
  min-height: ${pxToRem(20)}; /** css file conversion */
  &:empty {
    margin: 0;
  }
  [data-role='queryBuilder']:not([data-view-mode='true']) & {
    display: none !important;
  }
`;

export const InputContainer = styled.div`
  &&&& {
    flex: 1 1 auto;
    display: flex;
    &[data-isGeoField='true'] {
      flex: 1 1 100%;
    }
    &[data-isMultiSelectInput='true'] {
      flex: 1 1 100%;
    }
    height: max-content;
    > * {
      margin-bottom: 0;
    }
    [data-role='queryBuilder'][data-view-mode='true'] & {
      display: none !important;
      &[data-isGeoField='true'] {
        display: inherit;
      }
    }
  }
`;

export const inputFieldStyles = `
  &.ui.input {
    flex: 1 1 auto;
  }
  [type='text'],
  [data-role='date-input'],
  [data-role='time-input'],
  [data-role='increment'],
  [data-role='decrement'] {
    border-radius: 0 !important;
  }
`;

export const CriteriaTextInput = styled(SemanticUI.Input)`
  &&&& {
    ${inputFieldStyles}
  }
`;

export const StyledCoreNumberInput = styled(NumberInput)`
  &&&& {
    ${inputFieldStyles}
    touch-action: none;
  }
`;

export const StyledCoreUserMappingsDropdown = styled(Dropdown)`
  &&&& {
    display: flex;
    flex: 1 1 auto;
    border-radius: 0;
    [data-role='queryBuilder'][data-view-mode='true'] &:not(.geoField) {
      display: none !important;
    }
    [data-role='queryBuilder'][data-view-mode='true'] + & {
      flex: 1 1 50%;
    }
  }
`;

export const BooleanPickerContainer = styled.div<{ isDisabled: boolean }>`
  ${inputFieldStyles}
  align-items: center;
  display: flex;
  justify-content: space-between;
  background: #fff;
  min-height: ${pxToRem(38)}; /** css file conversion */
  border: ${pxToRem(1)} solid #d6d6d6; /** css file conversion */
  flex-wrap: nowrap;
  margin: 0;
  padding: 0 ${pxToRem(10)};
  width: 100%;
  gap: ${pxToRem(10)};

  ${({ isDisabled }) =>
    isDisabled &&
    `
    opacity: .45;
    pointer-events: none;
  `}
`;

export const BooleanPicker = styled.div<{ showErrorState: boolean }>`
  color: ${({ showErrorState }) => (showErrorState ? '#d14233' : 'inherit')};
  align-items: center;
  flex: 1;
  gap: ${pxToRem(5)};
  display: flex;
  > * {
    margin: 0;
  }
  &:hover {
    text-decoration: underline;
  }
`;

export const StyledCoreStackedToggle = styled(StackedToggle)`
  &&&& {
    border-radius: 0;
    min-width: ${pxToRem(72)}; /** css file conversion */
  }
`;

export const CriteriaDateFieldWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const StyledCoreDateRangePickerRelative = styled(DateRangePickerRelative)`
  &&&& {
    ${inputFieldStyles}
    &.ui.button {
      margin: 0;
      border-radius: 0;
      background: #fcfcfc;
      border: ${pxToRem(1)} solid #d6d6d6;
      position: relative;
      flex-wrap: wrap;
      flex: 1 1 auto;
      > .icon {
        background-color: unset;
        border-right: ${pxToRem(1)} solid #d6d6d6;
      }
      &:hover {
        border-color: #c3c3c5 !important;
        z-index: 1;
      }
    }
  }
`;

export const GeoLabel = styled.div`
  display: flex;
  align-items: center;
  background: #eff0f0; /** css file conversion */
  border-top: ${pxToRem(1)} solid #d6d6d6;
  border-bottom: ${pxToRem(1)} solid #d6d6d6;
  padding: 0 ${pxToRem(10)};
  [data-role='queryBuilder'][data-view-mode='true'] & {
    background: none;
    border: none;
    color: #717171;
    padding: 0 ${pxToRem(5)};
  }
`;

export const StyledCoreDistancePicker = styled(DistancePicker)`
  &&&& {
    display: flex;
    flex: 1 1 40%;
    min-width: ${pxToRem(180)}; /** css file conversion */
    max-width: ${pxToRem(300)}; /** css file conversion */
  }
`;

export const StyledCoreLocationPicker = styled(LocationPicker)`
  display: flex;
  flex: 1 1 60%;
`;

export const StyledTopTooltip = styled(Tooltip)`
  width: 100%;
  > span {
    width: 100%;
  }
  .ui.input {
    width: 100%;
  }
`;
